<template>
  <div class="tabs-navigation">
    <div class="tabs-container">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        :class="['tab', { active: activeTab === tab.key, disabled: tab.disabled }]"
        @click="handleTabClick(tab.key, tab.disabled)"
      >
        {{ tab.label }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Tab {
  key: string
  label: string
  disabled?: boolean
}

interface Props {
  tabs: Tab[]
  activeTab: string
}

interface Emits {
  (e: 'tab-change', tabKey: string): void
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const handleTabClick = (tabKey: string, disabled?: boolean) => {
  if (!disabled) {
    emit('tab-change', tabKey)
  }
}
</script>

<style scoped>
/* Frame 3466179 - .tabs-navigation */
.tabs-navigation {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  width: 100%;
  height: 57px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

/* Frame 3466193 - .tabs-container */
.tabs-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px;
  width: auto;
  min-width: 553px;
  max-width: 900px;
  height: 57px;
  background: #eaeaea;
  border-radius: 24px;
  flex: none;
  order: 0;
  flex-grow: 0;
  gap: 8px;
}

/* Frame 3466190, 3466191, 3466192 - .tab */
.tab {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 15px;
  width: auto;
  min-width: 120px;
  height: 41px;
  border-radius: 32px;
  flex: 1;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 140%;
  text-align: center;
  color: #2b2a2a;
}

.tab:hover:not(.disabled) {
  background: #f5f5f5;
}

.tab.active {
  background: #ffffff;
  font-weight: 700;
  color: #2b2a2a;
  padding: 8px 24px;
}

.tab.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
